"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortByIndexingArray = exports.shuffle = exports.pullFromSet = exports.print = exports.mergeUnique = exports.matchOnSome = exports.is = exports.intersects = exports.hasValue = exports.hasLength = exports.hasIndex = exports.filterValue = exports.filterByTerm = exports.condense = exports.castString = exports.addToSet = void 0;
var _lodash = require("lodash");
var string = _interopRequireWildcard(require("./string"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function (nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

/**
 * Mostly used with .find results.
 */
const hasIndex = v => v !== -1;
/**
 * Forces element into an array shape.
 */

exports.hasIndex = hasIndex;
const is = a => (0, _lodash.compact)(Array.isArray(a) ? a : [a]);
/**
 * Remove empty values.
 */

exports.is = is;
const condense = a => a.flat().filter(Boolean);
exports.condense = condense;
const print = arr => is(arr).join(', ');
/**
 * Cast a string to an array.
 */

exports.print = print;
const castString = v => {
  if (Array.isArray(v)) return v;
  if (typeof v === 'string' && v.length) return v.split(',').map(i => i.trim());
  return [];
};
/**
 * Ensure at least one value.
 */

exports.castString = castString;
const hasLength = v => Array.isArray(v) && v.length;
exports.hasLength = hasLength;
const filterValue = function () {
  let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let v = arguments.length > 1 ? arguments[1] : undefined;
  return a.filter(i => i !== v);
};
exports.filterValue = filterValue;
const hasValue = function () {
  let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let v = arguments.length > 1 ? arguments[1] : undefined;
  return hasIndex(a.findIndex(i => i === v));
};
/**
 * If adding an existing value, if will instead remove it from the array.
 */

exports.hasValue = hasValue;
const addToSet = function () {
  let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let v = arguments.length > 1 ? arguments[1] : undefined;
  let base = is(a);
  if (hasValue(base, v)) {
    base = filterValue(base, v);
  } else {
    base.push(v);
  }
  return (0, _lodash.uniq)(base.flat());
};
/**
 * Will filter from an array or return empty.
 */

exports.addToSet = addToSet;
const pullFromSet = function () {
  let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let v = arguments.length > 1 ? arguments[1] : undefined;
  return Array.isArray(a) ? filterValue(a, v) : [];
};
/**
 * Remove on match and fill on difference between three targets.
 * The first two are subject to change, while the last determines match or fill.
 */

exports.pullFromSet = pullFromSet;
const shuffle = function () {
  let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  const has = item => !c.includes(item);
  const keepInA = a.filter(has);
  const keepInB = b.filter(has);
  return [keepInA.concat((0, _lodash.difference)(b, keepInB)), keepInB.filter(has).concat((0, _lodash.difference)(a, keepInA))];
};
/**
 * Checks a term against a set of patterns.
 */

exports.shuffle = shuffle;
const matchOnSome = function () {
  let rules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let term = arguments.length > 1 ? arguments[1] : undefined;
  return hasLength(rules) && string.is(term) ? rules.some(rule => string.hasMatch(term, rule)) : false;
};
/**
 * Filter full array by search term.
 */

exports.matchOnSome = matchOnSome;
const filterByTerm = function () {
  let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let value = arguments.length > 1 ? arguments[1] : undefined;
  return is(a).filter(item => {
    if (typeof value !== 'string') return true;
    if (!value.length) return true;
    return JSON.stringify(item).toLowerCase().includes(value.toLowerCase());
  });
};
exports.filterByTerm = filterByTerm;
const mergeUnique = function () {
  let arr1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let arr2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return arr1.concat(arr2).reduce((acc, next) => {
    if (!acc.includes(next)) acc.push(next);
    return acc;
  }, []);
};
exports.mergeUnique = mergeUnique;
const intersects = function () {
  let arr1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let arr2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return arr1.filter(item => arr2.findIndex(val => {
    try {
      return new RegExp(`^${val.replace('.$.', '.(\\d+).')}$`).test(item);
    } catch (e) {
      return val === item;
    }
  }) !== -1);
};
exports.intersects = intersects;
const sortByIndexingArray = function () {
  let arr1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let arr2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const {
    active,
    inactive
  } = arr1.reduce((acc, next) => {
    if (arr2.includes(next)) {
      acc.active.push(next);
    } else {
      acc.inactive.push(next);
    }
    return acc;
  }, {
    active: [],
    inactive: []
  });
  return [...active.sort((a, b) => arr2.indexOf(a) - arr2.indexOf(b)), ...inactive.sort()];
};
exports.sortByIndexingArray = sortByIndexingArray;